import type { TppSnapshot } from './tppLocalDb';
import { TPP_XLSX_PATH } from './tppZipExcel';

export const ZIP_README_PATH = 'README.txt';
export const TPP_META_JSON_PATH = 'transit-pass-pool/meta.json';
export const TPP_PROOFS_PREFIX = 'transit-pass-pool/proofs/';

export function buildTppZipReadme(snap: TppSnapshot): string {
  const poolKey = snap.settings.poolKey;
  const counts = [
    `カード: ${snap.cards.length} 件`,
    `イベント: ${snap.events.length} 件`,
    `証跡: ${Object.keys(snap.files).length} 件`,
  ].join(' / ');

  return `交通系IC共用管理（Transit Pass Pool / TPP）
${'='.repeat(60)}
この ZIP は研究室等で共用する交通系 IC カードの貸出・返却・チャージ履歴を
まとめたデータです。研助が使えない場合でも Excel と証跡画像で確認できます。

【中身】
README.txt ........................... このファイル
${TPP_XLSX_PATH} ... データ本体（カード・イベント・設定）
${TPP_META_JSON_PATH} ............... リビジョン・更新日時
${TPP_PROOFS_PREFIX} ................ 返却時の証跡画像（イベントとファイル名で対応）

【プール】 ${poolKey}
【件数】 ${counts}
【更新】 revision ${snap.meta.revision} / ${snap.meta.updatedAt}

【研助を使わずに見る手順】
1. ${TPP_XLSX_PATH} を Excel または LibreOffice Calc で開く
2. シート「Events」「Cards」「Settings」を参照
3. 証跡画像は ${TPP_PROOFS_PREFIX} 以下。Events シートの proofFile 列を参照

【重要】
- Excel（${TPP_XLSX_PATH}）がデータの正本です。ZIP を開き直すと Excel の内容が読み込まれます。
- meta.json はリビジョン管理用です。手編集は非推奨です。
- 証跡ファイルの手動削除・リネームはデータ破損の原因になります。
- OneDrive / Google Drive 等の自動同期フォルダに置かないでください。

---
This archive contains shared transit IC card checkout/return/charge history.
Open ${TPP_XLSX_PATH} for the canonical spreadsheet data and ${TPP_PROOFS_PREFIX} for proof images.

Excel is the source of truth for cards, events, and settings.
`;
}
